import { render, staticRenderFns } from "./VirtualAccountListFilters.vue?vue&type=template&id=6edaf4ff&"
import script from "./VirtualAccountListFilters.vue?vue&type=script&lang=js&"
export * from "./VirtualAccountListFilters.vue?vue&type=script&lang=js&"
import style0 from "./VirtualAccountListFilters.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports